<script>
import StatusBadge from './StatusBadge.vue'

export default {
  components: { StatusBadge },
  props: {
    cliente:  { type: Object, default: null },
    salvando: { type: String, default: null },
    tipo:     { type: String, default: 'cliente' }, // 'cliente' | 'instalacao'
    /** Quando definido, etapa "Documento pessoal" pendente/reprovado exibe link para envio real. */
    clienteDetalheId: { type: [String, Number], default: null },
  },
  computed: {
    itens() {
      if (this.tipo === 'instalacao') {
        return [
          { campo: 'status_pdf_conta', icone: 'bx bx-file', titulo: 'PDF da conta',      subtitulo: 'Fatura de energia' },
          { campo: 'status_contrato',  icone: 'bx bx-pen',  titulo: 'Contrato', subtitulo: 'Assinatura digital' },
        ]
      }
      return [
        { campo: 'status_dados',     icone: 'bx bx-clipboard', titulo: 'Dados pessoais',    subtitulo: 'Nome, CPF, e-mail' },
        { campo: 'status_documento', icone: 'bx bx-id-card',   titulo: 'Documento pessoal', subtitulo: 'CNH ou RG' },
      ]
    },
  },
  methods: {
    atualizar(campo, status) {
      this.$emit('atualizar', { campo, status })
    },

    exibirLinkEnvioDocumento(item) {
      if (this.tipo !== 'cliente' || item.campo !== 'status_documento') {
        return false
      }
      if (this.clienteDetalheId == null || this.clienteDetalheId === '') {
        return false
      }
      const s = this.cliente[item.campo]
      return s === 'pendente' || s === 'reprovado'
    },
  },
}
</script>

<template>
  <div v-if="cliente">
    <div
      v-for="(item, idx) in itens"
      :key="item.campo"
      class="d-flex align-items-center justify-content-between py-3"
      :style="idx < itens.length - 1 ? 'border-bottom: 1px solid #d1d1e3;' : ''"
    >
      <!-- Ícone + título -->
      <div class="d-flex align-items-center">
        <div class="bg-light rounded p-2 mr-3" style="flex-shrink: 0;">
          <i :class="item.icone" class="font-size-18 d-block" style="line-height: 1;"></i>
        </div>
        <div>
          <p class="mb-0 font-weight-semibold font-size-14">{{ item.titulo }}</p>
          <p class="mb-0 font-size-12 text-muted">{{ item.subtitulo }}</p>
        </div>
      </div>

      <!-- Badge + ações -->
      <div class="d-flex align-items-center" style="gap: 6px; flex-shrink: 0; margin-left: 8px;">
        <StatusBadge :status="cliente[item.campo]" />

        <!-- Spinner enquanto salva -->
        <span
          v-if="salvando === item.campo"
          class="spinner-border spinner-border-sm text-primary"
        ></span>

        <!-- Documento: pendente ou reprovado → tela de envio (API). Demais etapas reprovadas: mock local. -->
        <template v-else>
          <template v-if="exibirLinkEnvioDocumento(item)">
            <router-link
              :to="'/energia/clientes/' + clienteDetalheId + '/documento'"
              class="btn btn-sm btn-soft-primary"
            >
              <i class="bx bx-upload mr-1"></i>
              {{ cliente[item.campo] === 'reprovado' ? 'Enviar novamente' : 'Enviar documento' }}
            </router-link>
          </template>
          <template v-else-if="cliente[item.campo] === 'reprovado'">
            <button class="btn btn-sm btn-soft-warning" @click="atualizar(item.campo, 'pendente')">
              <i class="bx bx-upload mr-1"></i>Enviar novamente
            </button>
          </template>
        </template>
      </div>
    </div>
  </div>
</template>
